import React, { Component } from 'react';
import '../css/LogoWall.css';

const logoNames = [
  "Acer", "CBM", "Chemtronics", "CreditEase", "Doday",
  "Dodohome", "EasyCard", "Ingensys", "Line Pay", "Miaoli County",
  "NVIDIA", "Taiwan Bio", "Chunghwa Telecom", "Uber Eats", "Universal Robots"
];

const logos = [
  "/logo/logowall_acer.svg",
  "/logo/logowall_cbm.svg",
  "/logo/logowall_chem.jpg",
  "/logo/logowall_credit.svg",
  "/logo/logowall_doday.svg",
  "/logo/logowall_dodohome.png",
  "/logo/logowall_easycard.svg",
  "/logo/logowall_ingensys.svg",
  "/logo/logowall_linepay.svg",
  "/logo/logowall_miaoli.svg",
  "/logo/logowall_nvidia.svg",
  "/logo/logowall_taiwanbio.png",
  "/logo/logowall_telecom.svg",
  "/logo/logowall_ubereats.svg",
  "/logo/logowall_ur.png"
];

const sectionTitle = {
  "zh": "值得信賴的合作夥伴",
  "en": "Trusted by Leading Companies",
  "ja": "信頼されるパートナー"
};

class LogoWall extends Component {
  render() {
    const lang = this.props.lang || 'en';

    if (this.props.mode === 'grid') {
      return (
        <div className="logowall-grid">
          {logos.map((src, i) => (
            <img key={i} src={src} alt={logoNames[i]} />
          ))}
        </div>
      );
    }

    return (
      <div className="logowall-section">
        <h2 className="logowall-title">{sectionTitle[lang]}</h2>
        <div className="marquee">
          <div className="marquee__group">
            {logos.map((src, i) => <img key={i} src={src} alt={logoNames[i]} />)}
          </div>
          <div className="marquee__group">
            {logos.map((src, i) => <img key={'d' + i} src={src} alt={logoNames[i]} />)}
          </div>
        </div>
      </div>
    );
  }

}

export default LogoWall;